import React from 'react'

import LimitReached from '@/components/LimitReached'

const LimitReachedPage = () => <LimitReached />

export default LimitReachedPage
